

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_146_2_FloatingHelperContent";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_146_2_FloatingHelperContent__root","title":"wds_1_146_2_FloatingHelperContent__title","action":"wds_1_146_2_FloatingHelperContent__action","image":"wds_1_146_2_FloatingHelperContent__image","footer":"wds_1_146_2_FloatingHelperContent__footer"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




